// @ts-strict-ignore
export const checkEquality = (value1, value2) => {
  if (
    typeof value1 === 'object'
    && typeof value2 === 'object'
    && +value1.data_route_id === +value2.data_route_id
  ) {
    return true;
  }

  if (+value1 === +value2) {
    return true;
  }

  return false;
};

export const searchAndDestroy = (expression, valueToDestroy) => {
  for (let i = expression.length - 1; i >= 0; i -= 1) {
    const value = expression[i];

    if (Array.isArray(value)) {
      const searchedValue = searchAndDestroy(value, valueToDestroy);
      expression[i] = searchedValue.length === 1 ? searchedValue[0] : searchedValue;
    } else if (checkEquality(valueToDestroy, value)) {
      if (i === expression.length - 1) {
        expression.splice(i - 1, 2);
        i -= 1;
      } else {
        expression.splice(i, 2);
      }
    }
  }

  return expression;
};

export const tokenize = (expression, tokenized = []) => {
  expression.forEach(value => {
    if (Array.isArray(value)) {
      tokenized.push('[', ...tokenize(value), ']');
    } else {
      tokenized.push(value);
    }
  });

  return tokenized;
};


export const detokenize = (expression, i = 0, detokenized = []) => {
  let index = i;

  while (index < expression.length) {
    const value = expression[index];

    if (value === ']') {
      return [detokenized, index + 1];
    }
    if (value === '[') {
      const [innerArray, newIndex] = detokenize(expression, index + 1);
      detokenized.push(innerArray);
      index = newIndex;
    } else {
      detokenized.push(value);
      index += 1;
    }
  }

  return detokenized;
};
